import League from "@Enums/Leagues";
import { Theme } from "@mui/material";
import BootcampMedal from "@Resources/game/metals/medal_1_bootcamp.png";
import BronzeMetal from "@Resources/game/metals/medal_1_bronze.png";
import SilverMetal from "@Resources/game/metals/medal_2_silver.png";
import GoldMetal from "@Resources/game/metals/medal_3_gold.png";
import ChampionsMetal from "@Resources/game/metals/medal_4_champions.png";
import { dsPrimaryGradient } from "@Themes/palettes/app-palette";

const leagueMedals: Record<League, string> = {
  [League.BOOTCAMP]: BootcampMedal,
  [League.BRONZE]: BronzeMetal,
  [League.SILVER]: SilverMetal,
  [League.GOLD]: GoldMetal,
  [League.CHAMPIONS]: ChampionsMetal,
};

const ratingMedals = [
  { max: 2000, medal: BootcampMedal },
  { max: 3000, medal: BronzeMetal },
  { max: 4000, medal: SilverMetal },
  { max: 5000, medal: GoldMetal },
  { max: Infinity, medal: ChampionsMetal },
];

const getMedalImage = (league: League) => {
  const medal = leagueMedals[league];
  return medal || BootcampMedal;
};

const getMedalBackgroundColor = (league: League, theme: Theme) => {
  const medalBgColors: Record<string, string> = {
    [League.BOOTCAMP]: theme.palette.dsPrimaryGradient.green,
    [League.BRONZE]: theme.palette.dsPrimaryGradient.brown,
    [League.SILVER]: theme.palette.dsPrimaryGradient.grey,
    [League.GOLD]: theme.palette.dsPrimaryGradient.orange,
    [League.CHAMPIONS]: dsPrimaryGradient.blue,
  };

  return medalBgColors[league];
};

const getMedalImageFromRating = (rating: number) => {
  const medal = ratingMedals.find(({ max }) => rating <= max);
  return medal?.medal || BootcampMedal;
};

export { getMedalBackgroundColor, getMedalImage, getMedalImageFromRating };
